/**
 * 스크롤 시 고정 헤더에 배경을 깔아 흰색 섹션 위에서도 아이콘 대비가 유지되도록 함.
 * 실제 헤더 높이를 --header-height에 동기화해 sticky 서브네비·scroll-margin과 맞춘다.
 */
const SCROLL_CLASS = "no-header--scrolling";
const THRESHOLD_PX = 4;

function syncHeaderHeightVar(header: HTMLElement): void {
    const h = Math.round(header.getBoundingClientRect().height);
    if (h > 0) {
        document.documentElement.style.setProperty("--header-height", `${h}px`);
    }
}

export function initHeaderScroll(): void {
    const header = document.querySelector<HTMLElement>(".no-header");
    if (!header) return;

    const update = (): void => {
        const y = window.scrollY ?? document.documentElement.scrollTop;
        header.classList.toggle(SCROLL_CLASS, y > THRESHOLD_PX);
    };

    syncHeaderHeightVar(header);
    if (typeof ResizeObserver === "function") {
        const ro = new ResizeObserver(() => syncHeaderHeightVar(header));
        ro.observe(header);
    }
    window.addEventListener("resize", () => syncHeaderHeightVar(header), { passive: true });

    update();
    window.addEventListener("scroll", update, { passive: true });
}
